module.exports = __webpack_public_path__ + "img/Konstruktion.781d54b8.svg";